import { render, staticRenderFns } from "./InterventionOverview.vue?vue&type=template&id=b239b83e&"
import script from "./InterventionOverview.vue?vue&type=script&lang=js&"
export * from "./InterventionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports